package ai.wagemix.net.client

import ai.wagemix.net.models.WMSharedMixCreate
import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

class WMCreateSharedMixRequestBuilder: FSAuthenticatedRequestBuilder<WMCreateSharedMixRequestBuilder, WMSharedMixCreate>() {

    override fun build(): FSRequest<WMSharedMixCreate> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "sharedMixes")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMCreateSharedMixRequestBuilder = this
}